import clsx from 'clsx';
import './LoadingSpinner.scss';

interface LoadingSpinnerProps {
    id?: string;
    className?: string;
    style?: React.CSSProperties;
    height?: string;
    color?: string;
    'data-testid'?: string;
}

export default function LoadingSpinner({
    id,
    className = '',
    style = {},
    // width = '12px',
    height = '14px',
    color = 'white',
    'data-testid': dataTestId = 'loading-spinner',
}: LoadingSpinnerProps) {
    return (
        <div id={id} data-testid={dataTestId} className={clsx('LoadingSpinnerWrapper', className)} style={style}>
            <div
                className="spin-icon"
                style={{
                    width: height,
                    height: height,
                    borderTopColor: color,
                    borderLeftColor: color,
                }}
            ></div>
        </div>
    );
}
